import LoadingSvg from "@assets/icons/loading.svg?react";
import style from "./index.module.scss";
import { useTranslation } from "react-i18next";
export default function Loading() {
  const { t: $t } = useTranslation();
  return (
    <div className="w-100 h-100 rounded-5 flex flex-col justify-start items-center p-[10px_0] gap-y-8 ml-[50%] mt-[50%] translate-[-50%]">
      <LoadingSvg className={style.animate} style={{ width: "100%" }} />
      <p className="font-400 color-[#fff]">{$t("title32")}</p>
    </div>
  );
}
